<div class="layout-topbar">
  <!-- Logo & Menu Toggle -->
  <div class="layout-topbar-logo-container">
    <button
      class="layout-menu-button layout-topbar-action"
      (click)="layoutService.onMenuToggle()"
      [attr.aria-label]="'topbar.toggleMenu' | translate"
      [pTooltip]="'topbar.toggleMenu' | translate"
      tooltipPosition="bottom"
    >
      <i class="pi pi-bars"></i>
    </button>
    <img src="/assets/brain-metal.png" style="max-height: 45px" alt="mindx">
    <!-- Agent Status Dropdown -->
    <div class="agent-status-container" *ngIf="user?.role === 'agent'">
      <ng-container *ngIf="states$ | async as states; else loadingStates">
        <p-dropdown
          [options]="states"
          [(ngModel)]="selectedState"
          optionLabel="label"
          [placeholder]="'topbar.statusPlaceholder' | translate"
          [showClear]="false"
          [disabled]="isStatusChanging"
          (onChange)="onStateChange($event)"
          [panelStyleClass]="'axede-dropdown-panel-dark status-panel-dark'"
          appendTo="body"
          class="agent-status-select"
        >
          <!-- Selected Item Template -->
          <ng-template pTemplate="selectedItem">
            <div
              class="selected-status-item"
              [ngClass]="'status-' + selectedState.value.toLowerCase()"
              [style.color]="selectedState.color"
              [style.background-color]="selectedState.backgroundColor"
            >
              <span
                class="status-circle"
                [style.background-color]="selectedState.color"
              ></span>
              <span
                class="agent-status-label"
                [style.color]="selectedState.color"
              >{{ selectedState.label }}</span>
            </div>
          </ng-template>

          <!-- Dropdown Option Template -->
          <ng-template pTemplate="item" let-state>
            <div
              class="status-option-item"
              [ngClass]="'status-' + state.value.toLowerCase()"
              [style.color]="state.color"
              [style.background-color]="state.backgroundColor"
            >
              <span
                class="status-circle"
                [style.background-color]="state.color"
              ></span>
              <div class="status-info">
                <div
                  class="status-name"
                  [style.color]="state.color"
                >{{ state.label }}</div>
              </div>
            </div>
          </ng-template>
        </p-dropdown>
      </ng-container>

      <ng-template #loadingStates>
        <i class="pi pi-spin pi-spinner" [attr.aria-label]="'topbar.loadingStates' | translate"></i>
      </ng-template>
    </div>

    <!-- User Info Show the username -->
    <div class="layout-topbar-user-info" #userInfoContainer>
      <span>{{ getUsername }}</span>
    </div>
  </div>
  <!-- /Logo & Menu Toggle -->

  <!-- Timer Box -->
  <div
    class="layout-topbar-timer-box"
    style="margin-right: 10px"
    [ngStyle]="{
      'background-color': selectedState.backgroundColor || '#444',
      'border-color': selectedState.color || '#fff',
      color: selectedState.color || '#fff'
    }"
  >
    <i class="pi pi-clock timer-icon"></i>
    <span class="timer-text">{{ elapsedTime }}</span>
  </div>
  <!-- /Timer Box -->


  <!-- Language Switcher -->
  <app-language-switcher style="margin-right: 10px"></app-language-switcher>
  <!-- /Language Switcher -->

  <!-- Change Workspace -->
  <button
    (click)="changeWorkspace()"
    style="color: white; cursor: pointer"
    [title]="'topbar.changeWorkspace' | translate"
  >
    <i class="pi pi-sync"></i>
  </button>
  <!-- /Change Workspace -->
</div>
